import { FunctionComponent, useMemo } from 'react';
import { Perf } from 'r3f-perf';

export const ConditionalPerf: FunctionComponent = () => {
    const enabled = useMemo(() => new URLSearchParams(window.location.search).has('perf'), []);
    if (enabled) {
        return <Perf />;
    }
    return null;
};
